import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/pc/partner_arrowr.png'
import _imports_1 from '@/assets/images/pc/partner_arrowl.png'


const _hoisted_1 = { class: "partner-box" }
const _hoisted_2 = { class: "partner-swiper" }
const _hoisted_3 = { class: "outSwiperBox" }
const _hoisted_4 = { class: "cover-img" }
const _hoisted_5 = { alt: "" }
const _hoisted_6 = { class: "cover-img" }
const _hoisted_7 = { alt: "" }
const _hoisted_8 = { class: "cover-img" }
const _hoisted_9 = { alt: "" }
const _hoisted_10 = { class: "cover-img" }
const _hoisted_11 = { alt: "" }
const _hoisted_12 = { class: "cover-img" }
const _hoisted_13 = { alt: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "big-title" }, [
      _createElementVNode("span", null, "PARTNERS")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_swiper, {
          autoplay: {delay: 2500,stopOnLastSlide:false,disableOnInteraction: true},
          "slides-per-view": 5,
          "slides-per-group": 5,
          "space-between": 10,
          loop: true,
          navigation: {nextEl: '.swiper-button-next',prevEl: '.swiper-button-prev'},
          modules: $setup.modules,
          class: "inSwiperBox"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/partner_1.png')]
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/partner_2.png')]
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/partner_5.png')]
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/partner_4.png')]
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_swiper_slide, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [
                    [_directive_lazy, require('@/assets/images/pc/partner_3.png')]
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modules"]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "swiper-button-prev" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ], -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "swiper-button-next" }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          })
        ], -1))
      ])
    ])
  ]))
}